import React from 'react';
import { cn } from '@/lib/utils';

interface GlassCardProps extends React.HTMLAttributes<HTMLDivElement> {
  header?: React.ReactNode;
  subtitle?: React.ReactNode;
  action?: React.ReactNode;
  footer?: React.ReactNode;
  footerClassName?: string;
  hoverable?: boolean;
  glow?: 'none' | 'primary' | 'emerald' | 'rose';
  noPadding?: boolean;
  contentClassName?: string;
  children?: React.ReactNode;
}

export const GlassCard: React.FC<GlassCardProps> = ({
  header,
  subtitle,
  action,
  footer,
  footerClassName,
  hoverable = false,
  glow: _glow = 'none',
  noPadding = false,
  contentClassName,
  className,
  children,
  ...props
}) => {
  return (
    <div
      className={cn(
        'bg-card text-card-foreground rounded-xl border border-border/80 relative overflow-hidden transition-all duration-200 shadow-xs',
        hoverable && 'hover:border-primary/50 cursor-pointer',
        className
      )}
      {...props}
    >
      {(header || action || subtitle) && (
        <div className="px-5 py-4 border-b border-border/60 flex items-center justify-between gap-4">
          <div className="min-w-0">
            {header && (
              typeof header === 'string' ? (
                <h3 className="text-sm font-bold text-foreground tracking-tight truncate">
                  {header}
                </h3>
              ) : (
                header
              )
            )}
            {subtitle && (
              typeof subtitle === 'string' ? (
                <p className="text-xs text-muted-foreground mt-0.5 truncate">{subtitle}</p>
              ) : (
                subtitle
              )
            )}
          </div>
          {action && (
            <div className="shrink-0 flex items-center gap-2">{action}</div>
          )}
        </div>
      )}

      <div className={cn(!noPadding && 'p-5', contentClassName)}>{children}</div>

      {footer && (
        <div
          className={cn(
            'px-5 py-3.5 bg-muted/30 border-t border-border/60 flex items-center justify-between text-xs text-muted-foreground',
            footerClassName
          )}
        >
          {footer}
        </div>
      )}
    </div>
  );
};
